exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".large-btn{\n    width: 40% !important;\n}\n\n.edit-user-btn-block{\n    margin-top: 30px;\n}\n\n.upper-block{\n    margin-bottom: 40px;\n}\n\n.down-block{\n    \n    border-top: 2px solid grey;\n}", ""]);

